import { render, staticRenderFns } from "./RRICAdmin.vue?vue&type=template&id=04b390b4&"
import script from "./RRICAdmin.vue?vue&type=script&lang=js&"
export * from "./RRICAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports